<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini" style="width: 100%;">
        <div class="formItemBox">
          <el-form-item label="模块名称:" prop="name">
            <el-input placeholder="" v-model="searchFrom.name"></el-input>
          </el-form-item>
          <el-form-item label="客户端类型:" prop="clientClassify">
            <el-select v-model="searchFrom.clientClassify" placeholder="请选择">
              <el-option v-for="val in options" :label="val.name" :value="val.id" :key="val.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间:" prop="createTime">
          <el-date-picker
              v-model="searchFrom.createTimes"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="addClick">新增</el-button>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="editFn(scope.row)">修改</el-button>
              <el-button type="text" size="mini" @click="delFn(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name"  min-width="220" :formatter="emptyFn" label="模块名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="code"  min-width="170" :formatter="emptyFn" label="模块编码"></el-table-column>
        <el-table-column prop="clientClassify"  min-width="140" :formatter="emptyFn" label="客户端类型">
          <template slot-scope="scope">
              {{['web端', '移动端'][scope.row.clientClassify-1]}}
          </template></el-table-column>
        <el-table-column prop="remark"  min-width="270" :formatter="emptyFn" label="模块描述" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createUserName"  min-width="130" :formatter="emptyFn" label="创建人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime"  min-width="160" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <el-dialog :title="title"  :visible.sync="SQMark" width="450px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQFrom" ref="SQFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="145px" size="mini">
        <div class="inpBox1">
            <div style="margin: 28px 0;">
                <el-form-item label="模块名称:" prop="name">
                  <el-input v-model="SQFrom.name" placeholder="" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="客户端类型:" prop="clientClassify">
                  <el-select v-model="SQFrom.clientClassify" placeholder="请选择">
                    <el-option v-for="val in options" :label="val.name" :value="val.id" :key="val.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="模块描述:" prop="remark" >
                  <el-input type="textarea" v-model="SQFrom.remark" style="width:180px" :rows="3" maxlength="50"></el-input>
                </el-form-item>
             </div>
             <p style="color:red;margin-left:30px">备注：请维护标准模块名称，尽快能维护完整备注信息！</p>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SQMark = false">取消</el-button>
        <el-button type="primary" @click="SQsave()" v-show="addBtnShow">确定</el-button>
        <el-button type="primary" @click="editSave()" v-show="editBtnShow">修改</el-button>
      </span>
   </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import {
  sModuleList, // 列表
  sModuleAdd, // 添加
  sModuleUpdate, // 修改
  sModuleDelete // 删除
} from '@/api/newCrm'
export default {
  data () {
    return {
      options: [
        { name: 'web端', id: 1 },
        { name: '移动端', id: 2 }
      ],
      title: '',
      addBtnShow: false,
      editBtnShow: false,
      SQFrom: {
      },
      SQMark: false,
      rules: {
        name: [
          { required: true, message: '请输入模块名称', trigger: 'blur' }
        ],
        clientClassify: [
          { required: true, message: '请选择客户端类型', trigger: 'blur' }
        ]
      },
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/systemSetup/address')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    // 添加
    addClick () {
      this.title = '添加模块'
      this.addBtnShow = true
      this.editBtnShow = false
      this.SQMark = true
    },
    SQsave () {
      this.$refs.SQFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sModuleAdd(this.SQFrom).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.SQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 修改
    editFn (row) {
      this.title = '修改模块'
      this.addBtnShow = false
      this.editBtnShow = true
      this.SQMark = true
      this.SQFrom = {
        id: row.id,
        name: row.name,
        remark: row.remark,
        clientClassify: row.clientClassify
      }
    },
    editSave () {
      this.$refs.SQFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sModuleUpdate(this.SQFrom).then(res => {
            loading.close()
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.SQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sModuleDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      sModuleList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      this.$refs['SQFrom'].clearValidate()
      this.SQFrom = {
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox1 .el-date-editor{
  width: 350px!important;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;
  }
}
/deep/.inpBox1 .el-input__inner {
    width: 180px;
}
</style>
